export const ServiceUrl = {
  SETTINGS: "v1/settings?type=website,socialmedia",
  COURSES: "v1/set/list-courses",
  DEPARTMENTS: "v1/set/list-dept",

  MENUS: "site/v1/menus/list-menus",
  LINKS: "site/v1/menus/list-link",
  GET_PAGE: "site/v1/page/get",
  GET_IMAGES: "site/v1/page/get-images",
  GET_YEAR: "site/v1/page/get-year",
  GET_EVENT: "site/v1/page/get-event",
  LIST_PAGES: "site/v1/page/list",
  VISIT_STATS: "site/v1/page/visit-stats",
  TODAY_THIRUKURAL: "site/v1/public/thirukural",
  COUNTS: "site/v1/page/counts",
  LIBRARY_COUNTS: "site/v1/page/library-counts",
  DAY_ORDER: "site/v1/page/day-order",
  SEARCH: "site/v1/page/page-search",

  // Department pages
  DEPT: {
    SLIDERS: "site/v1/dept/sliders",
    PAGE: "site/v1/dept/page",
    PAGE_INPUTS: "site/v1/dept/page-inputs",
    COURSES: "site/v1/dept/courses",
    FILES: "site/v1/dept/files",
    FACULTY: "site/v1/dept/faculty",
    ESSTABLISHMENT: "site/v1/dept/esstablishment",
  },

  LIST_SLIDERS: "site/v1/page/sliders",
  RECENT_GALLERY: "site/v1/page/recent-gallery",
  LIST_GALLERY: "site/v1/page/gallery",

  HOME_PAGE_SETTINGS: "site/v1/page/home-page-settings",

  FACULTY_PROFILE: {
    LIST_QUALIFICATION: "site/v1/faculty/list-qualification",
    LIST_THESIS: "site/v1/faculty/list-thesis",
    LIST_DOCTORAL: "site/v1/faculty/list-doctoral",
    LIST_DEVELOPMENT: "site/v1/faculty/list-development",
    LIST_EXAMINATION: "site/v1/faculty/list-examination",
    LIST_EXPERIENCE: "site/v1/faculty/list-experience",
    LIST_CURRENT_EXP: "site/v1/faculty/list-current-exp",
    LIST_RESEARCH_GUIDANCE: "site/v1/faculty/list-research-guidance",
    LIST_RESEARCH_PROJECTS: "site/v1/faculty/list-research-projects",
    LIST_AWARDS: "site/v1/faculty/list-awards",
    LIST_CONFERENCE: "site/v1/faculty/list-conference",
    LIST_PUBLICIATIONS: "site/v1/faculty/list-publications",
    LIST_ACHIEVEMENTS: "site/v1/faculty/list-achievements",
  },
};
